module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Afex Nigeria","short_name":"Afex Nigeria","start_url":"/","background_color":"#E1261C","theme_color":"#E1261C","display":"standalone","icon":"src/assets/images/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-147744926-1","head":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"1443229275832982"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
